import CalendarEventDeleteWidget from "./CalendarEventDeleteWidget";
import CalendarEventDraftWidget from "./CalendarEventDraftWidget";
import CalendarEventUpdateWidget from "./CalendarEventUpdateWidget";
import EmailDraftWidget from "./EmailDraftWidget";

export { hasAssistantReviewWidgets } from "./assistantReviewMessage";

const getItems = (value) => (Array.isArray(value) ? value : []);

const AssistantReviewWidgets = ({ message, renderContext = "chat" }) => {
  if (!message || message.error) return null;

  const calendarEventDrafts = getItems(message.calendarEventDrafts);
  const calendarEventDeletions = getItems(message.calendarEventDeletions);
  const calendarEventUpdates = getItems(message.calendarEventUpdates);
  const emailDrafts = getItems(message.emailDrafts);
  const portalZIndex = renderContext === "voice" ? 1200 : undefined;

  return (
    <>
      {calendarEventDrafts.map((draft, index) => (
        <CalendarEventDraftWidget
          key={`${draft.id || draft.startDateTimeIso}-${index}`}
          draft={draft}
          statusKey={`${message.id}::${draft.id || draft.startDateTimeIso}`}
          portalZIndex={portalZIndex}
        />
      ))}
      {calendarEventDeletions.map((deletion, index) => (
        <CalendarEventDeleteWidget
          key={`${deletion.id || deletion.eventId}-${index}`}
          deletion={deletion}
          statusKey={`${message.id}::${deletion.id || deletion.eventId}`}
        />
      ))}
      {calendarEventUpdates.map((update, index) => (
        <CalendarEventUpdateWidget
          key={`${update.id || update.eventId}-${index}`}
          update={update}
          statusKey={`${message.id}::${update.id || update.eventId}`}
          portalZIndex={portalZIndex}
        />
      ))}
      {emailDrafts.map((draft, index) => (
        <EmailDraftWidget
          key={`${draft.id || draft.subject}-${index}`}
          draft={draft}
          statusKey={`${message.id}::${draft.id || draft.subject}`}
          portalZIndex={portalZIndex}
        />
      ))}
    </>
  );
};

export default AssistantReviewWidgets;
